<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        dom-layout="scroll"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        :rows="rows"
        class="agGrid"
        @refresh="onRefresh"
        @selectionChanged="rowSelectionChanged"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        class="btn primary small outline"
        :disabled="selectedRows.length == 0"
        @click="deleteProductAttribute"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        class="btn primary small"
        :disabled="selectedRows.length !== 1"
        @click="editProductAttribute"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="openDialog">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="
        isEdit
          ? $t('dialog.productAttributeUnitUpdate')
          : $t('dialog.productAttributeUnitAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20"
                  name="Mã thuộc tính"
                >
                  <div class="das-form-input">
                    <div class="label required">Mã thuộc tính:</div>
                    <div class="child-w-80">
                      <input
                        v-model="attributeProdItem.code"
                        :disabled="isEdit"
                        type="text"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Việt"
                >
                  <div class="das-form-input">
                    <div class="label required">Tên tiếng Việt:</div>
                    <div class="child-w-80">
                      <input v-model="attributeProdItem.name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Anh"
                >
                  <div class="das-form-input">
                    <div class="label required">Tên tiếng Anh:</div>
                    <div class="child-w-80">
                      <input v-model="attributeProdItem.eng_name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required"
                  name="Danh mục thuộc tính"
                >
                  <div class="das-form-input">
                    <div class="label required">Danh mục thuộc tính:</div>
                    <select-with-search-table
                      :dropdown-width="400"
                      :rows="attributeCategoryOptions"
                      :columns="selectSearchCol1"
                      :multiple="isMultipleAttributeSearchTable"
                      :value="attributeProdItem.attribute_category_id"
                      :selected-index-field-value="
                        attributeProdItem.attribute_category_id
                      "
                      index-field="id"
                      @selectionChanged="onSelectRowOption1"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        {{ selectedData?.name }}
                      </template>
                    </select-with-search-table>
                    <!-- <div class="child-w-80">
                      <select v-model="attributeProdItem.attribute_category_id">
                        <option
                          v-for="item in attributeCategoryOptions"
                          :key="item.id"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div> -->
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateProductAttribute"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addProductAttribute">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import {
  getListProductAttributeApi,
  addProductAttributeApi,
  updateProductAttributeApi,
  deleteProductAttributeApi
} from '@/api/configuration/accounting/product/attributeProduct.js'
import { getListAttributeCategoryApi } from '@/api/configuration/accounting/product/attributeCategory.js'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      isMultipleAttributeSearchTable: false,
      selectedRows: [],
      selectSearchCol1: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          flex: 1
        },
        {
          headerName: 'Tên tiếng Việt',
          field: 'name',
          tooltipField: 'name',
          flex: 1
        }
      ],
      attributeCategoryOptions: [],
      loading: false,
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã thuộc tính',
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: 'Tên danh mục thuộc tính',
          field: 'attribute_category_name',
          minWidth: 200,
          tooltipField: 'attribute_category_name'
        },
        {
          headerName: 'Tên tiếng Việt',
          field: 'name',
          tooltipField: 'name'
        },
        {
          headerName: 'Tên tiếng Anh',
          field: 'eng_name',
          tooltipField: 'eng_name'
        }
      ],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {},
      attributeProdItem: {
        code: null,
        name: '',
        eng_name: '',
        attribute_category_id: null
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  async mounted() {
    const res = await getListAttributeCategoryApi()
    this.attributeCategoryOptions = res.data
    this.attachData()
  },
  methods: {
    rowSelectionChanged(row) {
      this.selectedRows = row
    },
    onSelectRowOption1(val) {
      this.attributeProdItem.attribute_category_id = val.id
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    resetInfo() {
      this.isEdit = false
      this.attributeProdItem = {
        code: null,
        name: '',
        eng_name: '',
        attribute_category_id: null
      }
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    // CRUD
    async addProductAttribute() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addProductAttributeApi(this.attributeProdItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editProductAttribute() {
      const row = this.selectedRows[0]
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.attributeProdItem, row)
    },
    async deleteProductAttribute() {
      const ids = this.selectedRows.map(item => item.id) || []
      this.$vxConfirm('Bạn chắc chắn muốn xoá danh mục này?', () => {
        deleteProductAttributeApi({
          ids: ids
        })
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async updateProductAttribute() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      this.attributeProdItem.id = rowsSelected[0].id
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateProductAttributeApi(this.attributeProdItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListProductAttributeApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.selectedRows = []
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
